import styled from "styled-components";
import { motion } from "framer-motion";

export const PCA_Container = styled(motion.div)`
	display: flex;
	margin-bottom: 25px;
`;

export const PCA_Body = styled(motion.div)`
	display: flex;
	align-items: center;
	width: 100%;
	min-height: 50px;
	padding: 14px 18px;
	border: 1px solid #b7ddb8;
	border-radius: 14px;
	background: linear-gradient(90deg, #f2fff2 0%, #fbfffb 100%);
	box-shadow: 0 8px 24px rgba(46, 125, 50, 0.03);
`;

export const PCA_Icon = styled(motion.div)`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 38px;
	width: 38px;
	height: 38px;
	margin-right: 14px;
	border-radius: 50%;
	background: #5fba63;
	color: #fff;
`;

export const PCA_Text = styled.div`
	display: flex;
	flex-direction: column;
	min-width: 0;
`;

export const PCA_Title = styled.div`
	font-size: 16px;
	font-weight: 700;
	line-height: 20px;
	color: #2e7d32;
`;

export const PCA_Value = styled.div`
	margin-top: 4px;
	font-size: 14px;
	font-weight: 500;
	line-height: 18px;
	color: #4f7f50;
`;

export const PCA_Code = styled.div`
	margin-left: auto;
	padding: 6px 14px;
	border-left: 1px solid #cfe8cf;
	font-size: 14px;
	font-weight: 700;
	color: #2e7d32;
	white-space: nowrap;
`;

export const PCA_CloseButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	margin-left: 10px;
	padding: 0;
	border: 0;
	border-radius: 50%;
	background: transparent;
	color: #3f8f43;
	cursor: pointer;
	transition: all 0.2s;

	&:hover {
		background: rgba(46, 125, 50, 0.08);
	}

	&:active {
		transform: scale(0.92);
	}
`;
